import apiService from '../api/apiService';

// Help-desk API for the merchant portal. Backed by the ROLE_MERCHANT-accessible
// endpoints under /api/v1/support.
export const SupportController = {
  createTicket: (body: {
    subject: string;
    category: string;
    message: string;
    orderId?: string;
    subOrderId?: string;
  }) => apiService.post('/support/tickets', body),

  getMyTickets: ({ page = 0, size = 20 } = {}) =>
    apiService.get(`/support/tickets/mine?page=${page}&size=${size}`),

  getTicket: (id: string) => apiService.get(`/support/tickets/${id}`),

  reply: (id: string, message: string) =>
    apiService.post(`/support/tickets/${id}/reply`, { message }),

  // ---- merchant inbox: customer tickets about this merchant's products ----
  getMerchantInbox: ({ page = 0, size = 50, status = '', category = '' } = {}) => {
    const q = new URLSearchParams({ page: String(page), size: String(size) });
    if (status) q.set('status', status);
    if (category) q.set('category', category);
    return apiService.get(`/support/tickets/merchant-inbox?${q.toString()}`);
  },

  // Owning merchant moves the ticket (IN_PROGRESS / RESOLVED / CLOSED).
  updateStatus: (id: string, status: string) =>
    apiService.patch(`/support/tickets/${id}/status`, { status }),

  // Hand the ticket to the platform (admin) when the merchant can't resolve it.
  escalate: (id: string) => apiService.patch(`/support/tickets/${id}/escalate`, {}),
};
